export default __webpack_public_path__ + "static/media/enhancements-and-upgrades.cf608502.svg";